import {Observable, switchMap, throwError} from 'rxjs';
import {createSelectMap, Store} from '@ngxs/store';
import {ApplicationSelectorState, ConfigState, SetAuthConfigs, SetConfigs, ShowSnackbarError} from '../../state';
import { Injectable, inject } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, tap} from 'rxjs/operators';
import { InitialDataService } from '../initial-data/initial-data.service';
import { environment } from '../../../../environments/environment';
import {AppConfigStateModel, InitialDataStateModel} from '../../../model';
import jwtDecode from "jwt-decode";

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly store = inject(Store);
  private readonly initialDataService = inject(InitialDataService);
  private readonly http = inject(HttpClient);

  selectors = createSelectMap({
    baseApiUrl: ConfigState.baseApiUrl,
    application: ApplicationSelectorState.application,
    environment: ApplicationSelectorState.environment,
    authorizationTokensUrl: ConfigState.authorizationTokensUrl
  });

  init(username: string, password: string): Observable<InitialDataStateModel> {
    this.store.dispatch([new SetConfigs(environment), new SetAuthConfigs(environment.auth)]);

    const login$ = this.http.post(this.selectors.authorizationTokensUrl(), {"username":username,"password":password})
      .pipe(tap((res)=>{
        const decodedToken: any = jwtDecode(res['accessToken']);
        const currentRoles: string[] = decodedToken?.realm_access?.roles;
        const dictionaryRoles = currentRoles.filter((role)=> role.includes('DICTIONARY_SERVICE.translations.ALL.WRITE') || role.includes('DICTIONARY_SERVICE.translations.ALL.READ'))
        if (dictionaryRoles.length > 0){
          localStorage.setItem('token', res['accessToken'])
        }else{
          this.store.dispatch(new ShowSnackbarError(`This user is not authorized to use the dictionary: Ask Roberto`));
          throw  new Error("No dictionary roles")
        }

      }))

    return login$.pipe(

      switchMap(()=>{
      return this.initialDataService.getInitialData().pipe(
        catchError((err: HttpErrorResponse) => {
          this.store.dispatch(new ShowSnackbarError(`could not fetch application initialization data`, { value: err?.message }));
          return throwError(() => err);
        })
      );
    }))
  }
}
